export function slugify(input: string): string {
  if (!input) return '';
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // non-alphanumeric -> dash
    .replace(/^-+|-+$/g, '')     // trim leading/trailing dashes
    .replace(/-{2,}/g, '-');     // collapse multiple dashes
}
